import platform from 'components/Trackers/platform'

export const ScreenViewedEvent = {
  feature: 'MOC Registration Funnel',
  event_description: 'Screen Viewed',
  platform,
  object: 'Screen',
  action: 'Viewed',
  object_name: 'registrationMOCProgressStepOne',
  screen: 'registrationMOCProgressStepOne',
  screen_name: 'registrationMOCProgressStepOne',
}

export const NextButtonTappedEvent = {
  feature: 'MOC Registration Funnel',
  event_description: 'MOC Progress Step One Next button tapped',
  platform,
  object: 'Button',
  action: 'Tapped',
  object_name: 'mocRegistrationProgressOneNext',
  screen: 'mocRegistrationFunnelProgressOneNext',
  screen_name: 'mocRegistrationFunnelProgressOneNext',
}
